import React from "react";
import styled from "styled-components";
import { AudioOutlined } from "@ant-design/icons";
import { Input as AntInput } from "antd";
import { ThemesColors } from "@themes/index";

interface ISearchFormProps {
    placeholder?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    size?: "large" | "middle" | "small";
    isHideVoice?: boolean;
    width?: string; // Новый пропс для ширины
}

const SearchInput = styled(AntInput.Search)<{ $width?: string }>`

    width: ${(props) => props.$width || "100%"}; 
    border-radius: 100px;
    transition: background 0.3s ease, transform 0.1s ease;

    &:hover {
        background-color: ${ThemesColors.skyBlue} !important;
    }

    &:active {
        background-color: ${ThemesColors.azureBlue} !important;
        transform: scale(0.98);
    }

    .ant-input-search-button {
        background-color: ${ThemesColors.mainBlueDark500};
    }
`;

const SearchForm: React.FC<ISearchFormProps> = ({
                                                    placeholder = "Search",
                                                    onClick,
                                                    onChange,
                                                    value,
                                                    size = "large",
                                                    style,
                                                    isHideVoice = true,
                                                    width = "100%", // По умолчанию ширина 100%
                                                }) => {
    return (
        <SearchInput
            placeholder={placeholder}
            enterButton
            size={size}
            onSearch={onClick}
            onChange={onChange}
            value={value}
            style={style}
            $width={width} // Передача ширины
            suffix={
                isHideVoice && (
                    <AudioOutlined
                        style={{
                            fontSize: 16,
                            color: "#1890FF",
                        }}
                    />
                )
            }
        />
    );
};

export default SearchForm;
